/**
 * Yotpo's star-rating widgets (e.g. on product cards) only scan the DOM for
 * `.yotpo`/`.yotpo-widget-instance` elements once, on initial page load.
 * Filtering or sorting a collection/search page swaps in a freshly rendered
 * product grid without a full page reload, so the new grid's widgets are
 * left blank until Yotpo is told to re-scan. `initWidgets()` is Yotpo's
 * documented hook for AJAX-loaded content:
 * https://support.yotpo.com/docs/loading-yotpo-with-ajax
 * `yotpo.initWidgets()` is the legacy API (this theme's widgets use the
 * legacy `class="yotpo"` markup, see blocks/_tab.liquid); the new-widgets
 * API is also called in case a product-card app block uses it instead.
 */
import { StandardEvents } from '@shopify/events';

/**
 * @param {Event & { promise?: Promise<unknown> }} event
 */
function refreshYotpoWidgets(event) {
  event.promise
    ?.then(() => {
      window.yotpo?.initWidgets?.();
      window.yotpoWidgetsContainer?.initWidgets?.();
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[yotpo-widget-refresh] Event promise rejected:', error);
    });
}

document.addEventListener(StandardEvents.collectionUpdate, refreshYotpoWidgets);
document.addEventListener(StandardEvents.searchUpdate, refreshYotpoWidgets);
